export default __webpack_public_path__ + "static/media/itempo.6f610839.png";